import getStore from '../store/Store';
import { action, mutator } from 'satcheljs';
import { ObservableMap } from 'mobx';
import getUrlOverrides from '../utils/overrides/getUrlOverrides';
import { setLogicalRing } from 'owa-config/lib/getLogicalRing';
import calculateLogicalRing from '../utils/calculateLogicalRing';
import { getLocalStorageOverrides } from '../utils/overrides/localStorageOverrides';
import { getVariantEnvironment } from 'owa-metatags';

export const FEATURES_QUERYSTRING_PARAMETER_NAME = 'features';
export const FLIGHT_DEVTOOLS_NAME = 'fwk-devtools';
export const FLIGHT_DOGFOOD_NAME = 'ring-dogfood';

export interface InitializeState {
    featureFlags: ObservableMap<string, boolean>;
    defaultFlags: ObservableMap<string, boolean>;
}

let featureFlagsInitialized: boolean = false;
export function areFeatureFlagsInitialized(): boolean {
    return featureFlagsInitialized;
}

export const INITIALIZE_FEATURE_FLAGS_ACTION_NAME = 'initializeFeatureFlags';

type FeatureMap = { [feature: string]: boolean };

const initializeFeatureFlags = action(
    INITIALIZE_FEATURE_FLAGS_ACTION_NAME,
    (flagsFromService?: string[]) => {
        const enabledFlagsFromService = flagsFromService || [];
        const flagsFromServiceObject: FeatureMap = {};
        enabledFlagsFromService.forEach(
            flagFromService => (flagsFromServiceObject[flagFromService.toLowerCase()] = true)
        );

        if (flagsFromServiceObject[FLIGHT_DOGFOOD_NAME] || getVariantEnvironment() === 'AGALL') {
            addOverrides(flagsFromServiceObject, getLocalStorageOverrides());
        }
        if (flagsFromServiceObject[FLIGHT_DEVTOOLS_NAME]) {
            addOverrides(
                flagsFromServiceObject,
                getUrlOverrides(FEATURES_QUERYSTRING_PARAMETER_NAME)
            );
        }

        return { enabledFlagsFromService, initialFlagsWithOverrides: flagsFromServiceObject };
    }
);

function addOverrides(flags: FeatureMap, overrides: FeatureMap): void {
    for (let key of Object.keys(overrides)) {
        flags[key] = overrides[key];
    }
}

mutator(initializeFeatureFlags, ({ enabledFlagsFromService, initialFlagsWithOverrides }) => {
    // Apply defaults from the service
    enabledFlagsFromService.forEach(featureName => {
        getStore().defaultFlags.set(featureName.toLowerCase(), true);
    });

    // Apply initial state w/ calculated overrides
    Object.keys(initialFlagsWithOverrides).forEach(featureName => {
        getStore().featureFlags.set(
            featureName.toLowerCase(),
            initialFlagsWithOverrides[featureName]
        );
    });

    setLogicalRing(calculateLogicalRing(feature => initialFlagsWithOverrides[feature]));

    featureFlagsInitialized = true;
});

export default initializeFeatureFlags;
